// Update contents object below
const contents = {
  header: 'Intel Corporation', //update with your client name
  logoTooltip: {
    href: 'https://www.intel.com/wonderful', //where the logo click drives to
    copy: '' // tooltip content
  },
  hero: {
    background: 'video', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: 'Crisis and Connectivity in Ukraine',
    copy: 'How Intel Corporation and The N50 Project Are Using Digital Solutions for Good'
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      {
        class: 'photo1',
        caption:
          'Egestas augue mauris tellus eget id aliquam. In id mattis dui, leo sed donec. Maecenas ultrices nec netus consectetur convallis egestas pretium. Velit sed vivamus blandit maecenas id enim tellus. Venenatis nunc elit fringilla quam viverra. Amet, arcu porta sed sed pretium enim nulla. Platea nec ipsum '
      },
      {
        class: 'photo2',
        caption:
          'Egestas augue mauris tellus eget id aliquam. In id mattis dui, leo sed donec. Maecenas ultrices nec netus consectetur convallis egestas pretium. Velit sed vivamus blandit maecenas id enim tellus. Venenatis nunc elit fringilla quam viverra. Amet, arcu porta sed sed pretium enim nulla. Platea nec ipsum '
      },
      {
        class: 'photo3',
        caption:
          'Local Galati community Intel volunteers set up, configure, and connect ruggedized laptops to be used for education and a variety of digital programs. (Bogdan Dinca/CORE)'
      },
      {
        class: 'photo4',
        caption:
          'Alejandro Espinosa Llano (top) and Alejandra Collazos Reina (below) of Computer Aid install PCC internet service for CORE’s local partner, Help Ukrainians, in Galati, Romania. (Bogdan Dinca/CORE)'
      },
      {
        class: 'photo5',
        caption:
          'Staff from Geeks Without Frontiers, Computer Aid, and World Vision arrive in the  early morning to begin setting up the first Portable Connectivity Center (PCC) at RomExpo in Bucharest, Romania. (Geeks Without Frontiers/World Vision)'
      },
      {
        class: 'photo6',
        caption: 'The team outfits the PCC in Bucharest. (Geeks Without Frontiers/World Vision)'
      },
      {
        class: 'photo7',
        caption:
          'At the request of Mykolay Latushkin of Help Ukrainians, the Ukraine national flag is mounted on the PCC. (Bogdan Dinca/CORE)'
      }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href: 'https://www.n50project.org/', //where the cta button click drives to
    copy: 'n50project.org/' //tooltip content
  }
};

export default contents;
